import React from 'react';
import { Card, Badge } from 'react-bootstrap';

function EstablishmentCard({ serviceTag, timestamp, onClick, elisathStatus, mariaDBStatus, onInfoClick }) {
  const date = timestamp ? new Date(timestamp) : null;
  const now = new Date();
  const isMonitoringStopped = date ? (now - date) > 5 * 60 * 1000 : false;
  const formattedServiceTag = serviceTag.replace(/_/g, ' ');

  const backgroundColor = isMonitoringStopped ? '#f8d7da' : '#155724';

/*  const dateTextStyle = {
    color: isMonitoringStopped ? '#721c24' : 'white',
    fontWeight: 'bold',
    marginBottom: '8px',
  };
*/
  const cardStyle = {
    cursor: 'pointer',
    margin: '10px',
    width: '100%',
    minHeight: '170px',
    padding: '15px',
    backgroundColor,
    color: isMonitoringStopped ? '#721c24' : 'white',
    boxSizing: 'border-box',
  };

  const cardBodyStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    padding: 0,
  };

  const buttonsContainerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center', // Centre horizontalement
    gap: '10px',
    flexWrap: 'wrap', // Permet au contenu de passer à la ligne si nécessaire
    maxWidth: '100%', // Empêche le débordement horizontal
    overflow: 'hidden',
  };

  const infoButtonStyle = {
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    border: 'none',
    backgroundColor: isMonitoringStopped ? '#721c24' : 'white',
    color: isMonitoringStopped ? 'white' : '#155724',
    fontWeight: 'bold',
    cursor: 'pointer',
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    userSelect: 'none',
    flexShrink: 0,
    minWidth: '28px',
    minHeight: '28px',
  };

  const renderServiceBadge = (name, status) => (
    <Badge
      key={name}
      bg={status === 'success' ? 'success' : 'danger'}
      style={{ whiteSpace: 'nowrap', flexShrink: 0 }}
    >
      {name}: {status === 'success' ? 'OK' : 'KO'}
    </Badge>
  );

// Style pour centrer la date au milieu verticalement
const middleSectionStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexGrow: 1,       // prend tout l’espace entre haut et bas
  fontWeight: 'bold',
  color: isMonitoringStopped ? '#721c24' : 'white',
};

return (
  <Card style={cardStyle}>
    <Card.Body onClick={onClick} style={cardBodyStyle}>

      {/* En haut : Titre du site */}
      <div>
        <Card.Title
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            wordBreak: 'break-word',
            marginBottom: '0', // pour éviter espace excessif
          }}
        >
          {formattedServiceTag}
        </Card.Title>
      </div>

      {/* Milieu : date centrée verticalement et horizontalement */}
      <div style={middleSectionStyle}>
        {date ? date.toLocaleString() : ''}
      </div>

      {/* En bas : ligne bouton + badges */}
      <div style={buttonsContainerStyle}>
        <button
          onClick={e => {
            e.stopPropagation();
            if (onInfoClick) onInfoClick();
          }}
          title="Informations"
          aria-label="Informations"
          style={infoButtonStyle}
        >
          i
        </button>

        {renderServiceBadge('Elisath', elisathStatus)}
        {renderServiceBadge('MariaDB', mariaDBStatus)}
      </div>

    </Card.Body>
  </Card>
);
}

export default EstablishmentCard;
